import { mapOrder } from 'services/utilities'
import { actions } from './actions'

const initialState = {
  fechasSenaladasUrl: {
    data: [],
    loading: false,
    error: '',
  },
  fechasSenaladasUrlSortImages: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function fechasSenaladasUrlReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FECHAS_SENALADAS_URL_LOAD_REQUESTED:
      return { ...state, fechasSenaladasUrl: { data:[], loading: true } }
    case actions.FECHAS_SENALADAS_URL_LOAD_SUCCEEDED:
      return {
        ...state,
        fechasSenaladasUrl: { 
          data: action.payload, 
          loading: false, 
          error: null 
        }
      }
    case actions.FECHAS_SENALADAS_URL_LOAD_FILED:
      return {
        ...state,
        fechasSenaladasUrl: { ...state.fechasSenaladasUrl, loading: false, error: action.error },
      }
    case actions.FECHA_SENALADA_URL_GET_SORT_IMAGES_REQUESTED:
      return {
        ...state,
        fechasSenaladasUrlSortImages: { ...state.fechasSenaladasUrlSortImages, loading: true },
      }
    case actions.FECHA_SENALADA_URL_GET_SORT_IMAGES_SUCCEEDED:
      return {
        ...state,
        fechasSenaladasUrlSortImages: {
          data: action.payload,
          loading: false,
        },
      }
    case actions.FECHA_SENALADA_URL_GET_SORT_IMAGES_FILED:
      return {
        ...state,
        fechasSenaladasUrlSortImages: {
          ...state.fechasSenaladasUrlSortImages,
          loading: false,
          error: action.error,
        },
      }
    case actions.FECHAS_SENALADAS_URL_INSERT_REQUESTED:
      return {
        ...state,
        fechasSenaladasUrl: { ...state.fechasSenaladasUrl, loading: true, error: '' },
      }
    case actions.FECHAS_SENALADAS_URL_INSERT_SUCCEEDED:
      return {
        ...state,
        fechasSenaladasUrl: {
          ...state.fechasSenaladasUrl,
          data: [].concat(action.payload, state.fechasSenaladasUrl.data),
          loading: false,
          error: '',
        },
      }
    case actions.FECHAS_SENALADAS_URL_INSERT_FILED:
      return {
        ...state,
        fechasSenaladasUrl: { ...state.fechasSenaladasUrl, loading: false, error: action.error },
      }
    case actions.FECHAS_SENALADAS_URL_UPDATE_REQUESTED:
      return {
        ...state,
        fechasSenaladasUrl: { ...state.fechasSenaladasUrl, loading: true, error: '' },
      }
    case actions.FECHAS_SENALADAS_URL_UPDATE_SUCCEEDED:
      return {
        ...state,
        fechasSenaladasUrl: {
          ...state.fechasSenaladasUrl,
          data: state.fechasSenaladasUrl.data.map(fecS =>
            fecS.id === action.payload.id ? action.payload : fecS,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.FECHAS_SENALADAS_URL_UPDATE_FILED:
      return {
        ...state,
        fechasSenaladasUrl: { ...state.fechasSenaladasUrl, loading: false, error: action.error },
      }

    case actions.FECHA_SENALADA_URL_DELETE_REQUESTED:
      return {
        ...state,
        fechasSenaladasUrl: { ...state.fechasSenaladasUrl, loading: true, error: '' },
      }
    case actions.FECHA_SENALADA_URL_DELETE_SUCCEEDED:
      return {
        ...state,
        fechasSenaladasUrl: {
          ...state.fechasSenaladasUrl,
          data: state.fechasSenaladasUrl.data.filter(fechaS => fechaS.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_SENALADA_URL_DELETE_FILED:
      return {
        ...state,
        fechasSenaladasUrl: { ...state.fechasSenaladasUrl, loading: false, error: action.error },
      }
    case actions.FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_REQUESTED:
      return {
        ...state,
        fechasSenaladasUrlSortImages: {
          data: mapOrder(state.fechasSenaladasUrlSortImages.data, action.payload, 'id'),
          loading: true,
        },
      }
    case actions.FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_SUCCEEDED:
      return {
        ...state,
        fechasSenaladasUrlSortImages: {
          data: mapOrder(state.fechasSenaladasUrlSortImages.data, action.payload, 'id'),
          loading: false,
        },
      }
    case actions.FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_FILED:
      return {
        ...state,
        fechasSenaladasUrlSortImages: {
          ...state.fechasSenaladasUrlSortImages,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
